import { render, staticRenderFns } from "./LoadingDetails.vue?vue&type=template&id=1a37f24c&scoped=true&"
import script from "./LoadingDetails.vue?vue&type=script&lang=js&"
export * from "./LoadingDetails.vue?vue&type=script&lang=js&"
import style0 from "./LoadingDetails.vue?vue&type=style&index=0&id=1a37f24c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a37f24c",
  null
  
)

export default component.exports